






































































































export default {
    name: 'links-section',
    props: {
        sectionHeaderText: {
            type: String,
            default: '',
        },
        sectionItems: {
            type: Array,
            default: () => [],
        },
    },
};
